import { TaskStatus, taskStatusOptions } from './types';
import { TaskStatusTag } from './TaskStatusTag';
import { ComponentProps, ReactElement } from 'react';
import { MenuItem, MenuList, PopoverRoot, PopoverTrigger, PopoverPopup } from '@ff-it/ui';

type StatusSelectorProps = {
  onStatusChange: (status: TaskStatus) => void;
} & ComponentProps<typeof TaskStatusTag>;

export function TaskStatusSelector({ state, onStatusChange, ...tagProps }: StatusSelectorProps): ReactElement {
  return (
    <PopoverRoot>
      <PopoverTrigger>
        <TaskStatusTag state={state} role="button" iconAfter="chevron-down" {...tagProps} />
      </PopoverTrigger>
      <PopoverPopup closeOnContentClick placement="bottom-start">
        <MenuList size="sm">
          {taskStatusOptions.map(({ value }) => (
            <MenuItem
              lineHeight="1"
              key={value}
              label={<TaskStatusTag state={value} appearance="naked" />}
              active={state === value}
              onClick={() => onStatusChange(value)}
              disabled={state === value}
            />
          ))}
        </MenuList>
      </PopoverPopup>
    </PopoverRoot>
  );
}
